export default "__VITE_ASSET__f98b7ae6__"